import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';

export const CTA = () => {
  const benefits = [
    'Cadastro gratuito',
    'Sem cartão de crédito',
    'Acesso imediato',
  ];

  return (
    <section className="cta-gradient section-padding relative overflow-hidden" data-testid="cta-section">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-testid="cta-title">
            Pronto para ter controle total das suas finanças?
          </h2>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto" data-testid="cta-description">
            Comece agora mesmo a organizar suas contas a pagar e receber. É grátis e leva menos de 1 minuto para criar sua conta.
          </p>

          {/* CTA Button */}
          <motion.a
            href="https://app.dremais.com.br"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="inline-block mb-8"
            data-testid="cta-button"
          >
            <Button className="bg-white text-[#047857] hover:bg-slate-100 text-lg px-10 py-6 rounded-full font-bold shadow-xl hover:shadow-2xl transition-all duration-300">
              Criar Conta Gratuita
              <ArrowRight className="w-6 h-6 ml-2" />
            </Button>
          </motion.a>

          {/* Benefits */}
          <div className="flex flex-wrap gap-6 justify-center" data-testid="cta-benefits">
            {benefits.map((benefit, index) => (
              <motion.div
                key={benefit}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 + index * 0.1 }}
                className="flex items-center gap-2 text-white"
              >
                <CheckCircle2 className="w-5 h-5 text-[#D1FAE5]" />
                <span className="font-medium">{benefit}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
